import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { Container, Input, DoubleField, DateTime, ButtonsContainer, DictFilter, ParkingFilter, DateSelect, CategoryFilter, ClassFilter } from 'libs/form';
import { ResetBtn, UseBtn } from 'libs/ui';

const Filter = (props) => {
  const { t } = useTranslation();

  const { handleSubmit, reset, change } = props;

  return (
    <Container /*height='160px'*/>
      <form onSubmit={handleSubmit}>
        <DictFilter w={120} dict="tariff.status" />

        <DictFilter w={100} dict="tariff.type" />

        <Input width="222px" name="name" type="text" label={t('grid.Название')} placeholder={t('filter.Предприниматели')} />

        <CategoryFilter multiple />

        <ClassFilter multiple />

        <DateSelect from_name="time_from" to_name="time_to" change={change}>
          <DoubleField>
            <DateTime width="160px" name="time_from" type="dateTime" label={t('form.Начало действия')} />
            <DateTime width="160px" name="time_to" type="dateTime" />
          </DoubleField>
        </DateSelect>

        <DateSelect lastField from_name="created_at_from" to_name="created_at_to" change={change}>
          <DoubleField>
            <DateTime width="160px" name="created_at_from" type="dateTime" label={t('form.Дата создания')} />
            <DateTime width="160px" name="created_at_to" type="dateTime" />
          </DoubleField>
        </DateSelect>

        <ParkingFilter />

        <ButtonsContainer>
          <ResetBtn onClick={reset} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'tariffFilter',
  destroyOnUnmount: false,
  initialValues: { status: 'active' },
})(Filter);
